export default __webpack_public_path__ + "static/placeholder-92627aaa1228f6f3056a17917bd6a364.jpg";